import { exists } from '@engine/lib/utility/exists';
import { options } from '@engine/features/apply_chosen';
var terminal_supports_travel = false;

function TravelInternalUtils() {
  function updateItemIndex(item, index) {
    $('.travel-entry-index', item).html(index);
  }

  function showRemoveButton(entry) {
    $('.hidden.remove-travel-entry', entry).removeClass('hidden');
  }

  function loadTravelTemplate(callback) {
    var card_number = $('input[name*=card_number]').val();
    var travel_type = $('#travel_type').val();
    var $terminalSelect = $('input[name$="_transaction[terminal_id]"]');
    var terminal_id = $terminalSelect.val();
    var form_action = $terminalSelect.closest('form').attr('action');
    var trx_type = form_action.replace(/.*?virtual-terminal\/(\w*).*/i, '$1');
    var reference_id = $('input[name*=reference_id]').val();

    if (terminal_id && terminal_supports_travel && (card_number && travel_type || reference_id)) {
      $.ajax({
        type: 'GET',
        url: '/virtual-terminal/travel_data',
        dataType: 'html',
        data: {
          terminal_id: terminal_id,
          card_number: card_number,
          travel_type: travel_type,
          transaction_type: trx_type,
          reference_id: reference_id
        }
      }).done(function (travel_data) {
        callback(travel_data, trx_type);
      });
    }
  }

  function findLastIndex(name, container) {
    var last_selector = '.' + name + '-container .' + name + ':last .travel-entry-index';
    var last = $(last_selector, container);
    var last_index = parseInt(last.text(), 10) + 1;
    return last_index;
  }

  function cloneFields(inputs_selector, travel_data_container) {
    var inputs = $(inputs_selector, travel_data_container).clone();
    var count = $(inputs_selector.replace(':first', '')).length + 1;
    $('input', inputs).val('');
    $('select', inputs).val('');
    $('.chosen-container', inputs).remove();

    function updateAttributeIndex(attribute) {
      var elements = $(inputs).find('[' + attribute + ']');
      elements.each(function (index, element) {
        var value = $(element).attr(attribute).replace('1', count);
        $(element).attr(attribute, value);
      });
    }

    updateAttributeIndex('for');
    updateAttributeIndex('id');
    return inputs;
  }

  return {
    updateItemIndex: updateItemIndex,
    showRemoveButton: showRemoveButton,
    loadTravelTemplate: loadTravelTemplate,
    findLastIndex: findLastIndex,
    cloneFields: cloneFields
  };
}

var TravelUtil = new TravelInternalUtils();

function bindSelectAndDateTimeInputs(scope) {
  $('.travel_date_time_input', scope).datetimepicker();
  $('.for_chosen', scope).chosen(options);
}

function updateSelectOptions($selector, new_options, with_empty) {
  $selector.html('');

  if (with_empty) {
    $selector.append($('<option/>'));
  }

  $.each(new_options, function (key, value) {
    var $option = $('<option/>').attr('value', key).text(value);
    $selector.append($option);
  });
  $selector.trigger('chosen:updated');
}

function toggleTravelData(supports_travel, supports_travel_types) {
  terminal_supports_travel = supports_travel;
  var $travel_type = $('#travel_type');

  if (supports_travel) {
    updateSelectOptions($travel_type, supports_travel_types, true);
    $('.travel-container').removeClass('hidden');
  } else {
    $('.travel-container').addClass('hidden');
    $travel_type.val('');
    $('.travel-container .travel-data-container').html('');
  }
}

function listenForAddClick(selector) {
  var travel_data_container = $('.travel-data-container');
  $(selector, travel_data_container).on('click', function () {
    var name = selector.replace('#add_', '') + 's';
    var inputs_selector = '.' + name + '-container .' + name + ':first';
    var inputs = TravelUtil.cloneFields(inputs_selector, travel_data_container);
    bindSelectAndDateTimeInputs(inputs);
    TravelUtil.updateItemIndex(inputs, TravelUtil.findLastIndex(name, travel_data_container));
    TravelUtil.showRemoveButton(inputs);
    $('.' + name + '-container').append(inputs);
  });
}

function listenForAdd() {
  listenForAddClick('#add_leg');
  listenForAddClick('#add_tax');
  listenForAddClick('#add_charge');
}

function listenForChange() {
  if (!exists($('.travel-data-container'))) {
    return;
  }

  var inputs = ['#travel_type', 'input[name*=card_number]', 'input[name*=reference_id]'].join(',');
  $(inputs).on('change', function () {
    TravelUtil.loadTravelTemplate(function (travel_data, trx_type) {
      var travel_data_container = $('.travel-data-container');
      travel_data_container.html(travel_data);
      bindSelectAndDateTimeInputs(travel_data_container);
      listenForAdd();

      if (trx_type === 'authorize' || trx_type === 'authorize3d') {
        $('.required', travel_data_container).removeClass('required');
      }
    });
  });
}

function listenForRemoveEntryClick() {
  $(document).on('click', '.remove-travel-entry', function () {
    $(this).closest('.row').parent().remove();
  });
}

var Travel = {
  toggleTravelData: toggleTravelData,
  listenForRemoveEntryClick: listenForRemoveEntryClick,
  listenForAdd: listenForAdd,
  listenForChange: listenForChange
};
export default Travel;